import axios from "axios";

export default {
  namespaced: true,

  state: {
    allApplicants: [],
  },

  getters: {
    getApplicants: (state) => state.allApplicants,
  },
  actions: {
    requestAllApplicants({ commit }) {
      axios.get("/allApplicants").then(({ data }) => {
        commit("SET_APPLICANTS", data);
      });
    },
    requestFilteredApplicants({ commit }, filters) {
      axios.post("/filteredApplicants", filters).then(({ data }) => {
        commit("SET_APPLICANTS", data);
      });
    },

    getStatusCounts(context, filters) {
      console.log("Getting status counts with filters:", filters);
      context.dispatch("spinner/showSpinner", null, { root: true });

      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          url: "/admin/applications/status-counts",
          params: filters,
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            resolve(response.data);
          })
          .catch((error) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            console.error("Status counts error:", error);
            reject(error);
          });
      });
    },

    //   downloadApplications

    downloadFilterApplications(context, params) {
      console.log("Download params:", params);
      context.dispatch("spinner/showSpinner", null, { root: true });

      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          url: "/admin/download_filter_applications",
          params: params,
          responseType: "blob", // Always blob for file downloads
          timeout: 60000, // 60 second timeout
          headers: {
            Accept: "application/octet-stream",
          },
        })
          .then((response) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });

            // Resolve the full response so callers can read the
            // Content-Disposition filename from the headers.
            resolve(response);
          })
          .catch(async (error) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });

            // Because responseType is "blob", a JSON error body arrives
            // as a Blob. Try to read it back into a useful message.
            let serverMessage = null;
            if (error.response && error.response.data instanceof Blob) {
              try {
                const text = await error.response.data.text();
                const parsed = JSON.parse(text);
                serverMessage = parsed.message || parsed.error || null;
              } catch (e) {
                // Not JSON — ignore and fall back to status messages.
              }
            }

            // Enhanced error handling
            let errorMessage = serverMessage || "Download failed";

            if (!serverMessage && error.response) {
              if (error.response.status === 404) {
                errorMessage = "No applications found matching your criteria";
              } else if (error.response.status === 422) {
                errorMessage = "Invalid download parameters";
              } else if (error.response.status === 500) {
                errorMessage = "Server error during download";
              }
            } else if (!serverMessage && error.code === "ECONNABORTED") {
              errorMessage = "Download timeout - please try with fewer records";
            }

            reject({
              ...error,
              message: errorMessage,
            });
          });
      });
    },

    // Helper method to extract filename from response headers
    getFilenameFromResponse(response) {
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          return filenameMatch[1];
        }
      }
      return null;
    },

    getReferees(context, applicationId) {
      context.dispatch("spinner/showSpinner", null, { root: true });

      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          url: `/admin/applications/${applicationId}/referees`,
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            resolve(response.data);
          })
          .catch((error) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            console.error("Get referees error:", error);
            reject(error);
          });
      });
    },

    // Download recommendation PDF
    downloadRecommendation(context, { applicationId, refereeId }) {
      console.log("Downloading recommendation:", { applicationId, refereeId });
      context.dispatch("spinner/showSpinner", null, { root: true });

      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          url: `/admin/applications/${applicationId}/recommendations/${refereeId}/download`,
          responseType: "blob",
          timeout: 30000,
          headers: {
            Accept: "application/pdf",
          },
        })
          .then((response) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            resolve(response.data);
          })
          .catch((error) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });

            let errorMessage = "Failed to download recommendation";
            if (error.response?.status === 404) {
              errorMessage = "Recommendation not found";
            } else if (error.response?.status === 403) {
              errorMessage = "Access denied";
            }

            reject({
              ...error,
              message: errorMessage,
            });
          });
      });
    },
  },

  mutations: {
    SET_APPLICANTS: (state, data) => {
      state.allApplicants = data;
    },
  },
};
